import { FC, Suspense } from 'react';
import { SharingCardMeta } from './sharing-card';
import { ArticleJsonLD } from './json-ld';

export const ExperienceHead: FC = () => {
  return (
    <>
      <SharingCardMeta />
      <ArticleJsonLD />
    </>
  );
};
